

// PlatformTag.jsx
import React from 'react';
import { useTheme } from '@/managers/ThemeProvider';

const PlatformTag = ({ platform, hasKey = false, compact = false }) => {
    const { isDarkTheme } = useTheme();
    
    const getPlatformName = (platformStr) => {
        const p = String(platformStr).toUpperCase();
        if (p.startsWith('CUSTOM_')) return 'Custom';
        switch (p) {
            case 'OPENAI': return 'OpenAI';
            case 'CLAUDE': return 'Claude';
            case 'GEMINI': return 'Gemini';
            case 'MISTRAL': return 'Mistral';
            case 'PALM': return 'PaLM';
            case 'LLAMA': return 'Llama';
            default: return platformStr;
        }
    };

    const getPlatformInitial = (platformStr) => {
        const p = String(platformStr).toUpperCase();
        if (p.startsWith('CUSTOM_')) return 'C';
        switch (p) {
            case 'OPENAI': return 'O';
            case 'CLAUDE': return 'C';
            case 'GEMINI': return 'G';
            case 'MISTRAL': return 'M';
            case 'PALM': return 'P';
            case 'LLAMA': return 'L';
            default: return p.charAt(0) || '';
        }
    };

    const getTagStyles = () => {
        const p = String(platform).toUpperCase();
        const base = `inline-flex items-center transition-colors duration-200 ${compact ? 'px-1 py-0.5 rounded text-[10px] font-bold' : 'px-1.5 py-0.5 rounded-sm text-[10px]'}`;
        const keyStateStyle = hasKey ? '' : 'opacity-40';

        let bgColor = '';
        let textColor = '';

        if (p.startsWith('CUSTOM_')) {
            bgColor = isDarkTheme ? 'bg-amber-500/10' : 'bg-amber-500/20';
            textColor = isDarkTheme ? 'text-amber-400' : 'text-amber-800';
            return `${base} ${bgColor} ${textColor} ${keyStateStyle}`;
        }

        switch (p) {
            case 'OPENAI':
                bgColor = isDarkTheme ? 'bg-emerald-500/10' : 'bg-emerald-500/20';
                textColor = isDarkTheme ? 'text-emerald-400' : 'text-emerald-800';
                break;
            case 'CLAUDE':
                bgColor = isDarkTheme ? 'bg-[#F6A192]/10' : 'bg-[#F6A192]/20';
                textColor = isDarkTheme ? 'text-[#F6A192]' : 'text-[#8B5C52]';
                break;
            case 'GEMINI':
                bgColor = isDarkTheme ? 'bg-violet-400/10' : 'bg-violet-400/20';
                textColor = isDarkTheme ? 'text-violet-400' : 'text-violet-800';
                break;
            case 'MISTRAL':
                bgColor = isDarkTheme ? 'bg-blue-400/10' : 'bg-blue-400/20';
                textColor = isDarkTheme ? 'text-blue-400' : 'text-blue-800';
                break;
            case 'PALM':
                bgColor = isDarkTheme ? 'bg-green-400/10' : 'bg-green-400/20';
                textColor = isDarkTheme ? 'text-green-400' : 'text-green-800';
                break;
            case 'LLAMA':
                bgColor = isDarkTheme ? 'bg-orange-400/10' : 'bg-orange-400/20';
                textColor = isDarkTheme ? 'text-orange-400' : 'text-orange-800';
                break;
            default:
                bgColor = 'bg-surface-dark';
                textColor = 'text-on-surface-dim';
                break;
        }

        return `${base} ${bgColor} ${textColor} ${keyStateStyle}`;
    };

    return (
        <span
            className={getTagStyles()}
            style={compact
                ? { minWidth: 16, justifyContent: 'center', textAlign: 'center' }
                : undefined}
        >
            {compact ? getPlatformInitial(platform) : getPlatformName(platform)}
        </span>
    );
};

export default PlatformTag;